/**
 * obsolete Adds map bookmarks to the bookmarks collection
 * @module render-bookmarks
 */

import Collection = require("../collections/base-collection");
import Utils = require("../utils");
import Portal = require("portal-gis");
import Mediator = require("../mediator");
import Base = require("./base-command");

class Command extends Base<any> {

    static about = `
Obsolete.  Remove this command.
    `;

    execute(args: any) {
        console.log("adding configuration bookmarks to bookmark collection");
        var config = this.mediator.config;
        if (config) {
            if (config.Map.Bookmarks) {
                Utils.once<Collection<Portal.MapBookmarkLeaf>>(this.mediator.model, "bookmark-model", model => {
                    config.Map.Bookmarks.Bookmarks.forEach(b => model.merge(b));
                });
            }
        }
    }

}

export = Command;
